import React from "react";

const Header = ({ isDisabled }) => {
  return (
    <header
      style={{
        ...headerStyle,
        pointerEvents: isDisabled ? "none" : "auto",
      }}
    >
      <div style={headerContentStyle} onClick={() => window.location.reload()}>
        <div>
          <h1 style={titleStyle}>GetRecd</h1>
        </div>
      </div>
    </header>
  );
};

// Styles
const headerStyle = {
  display: "flex",
  fontFamily: "Manrope, sans-serif",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: "#1B2872",
  color: "#ffffff",
  padding: "10px 20px",
  boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
  fontFamily: "Arial, sans-serif",
};

const headerContentStyle = {
  display: "flex",
  cursor: "pointer",
  color: "#37DDF6",
  alignItems: "center",
  gap: "10px",
};

const logoStyle = {
  fontSize: "2.5rem",
};

const titleStyle = {
  fontFamily: "Manrope, sans-serif",
  fontSize: "1.5rem",
  fontWeight: "bold",
  margin: 0,
};

export default Header;
